import React from 'react';
import { TextField, TextFieldProps } from '@mui/material';

interface NumberTextFieldProps extends Omit<TextFieldProps, 'onChange'> {
  value: string;
  onChange: (value: string) => void;
}

const NumberTextField: React.FC<NumberTextFieldProps> = ({
  value,
  onChange,
  ...props
}) => {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const inputValue = e.target.value.replace(',', '.');
    if (/^\d*\.?\d*$/.test(inputValue) && Number(inputValue) >= 0) {
      onChange(inputValue);
    }
  };

  return (
    <TextField
      value={value}
      onChange={handleChange}
      {...props}
    />
  );
};

export default NumberTextField;